function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Expired Modal
 * 
 */
import React, { Component } from 'react';
import './ExpiredModal.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class ExpiredModal extends Component {
  constructor(props) {
    super(props);
    // $FlowFixMe
    _defineProperty(this, "buttonRef", void 0);
    /**
     * handleKeydown
     */
    _defineProperty(this, "handleKeydown", e => {
      // $FlowFixMe
      const {
        key
      } = e;
      const {
        onAction
      } = this.props;
      const {
        focus
      } = this.state;
      if (focus && (key === 'Enter' || key === ' ')) {
        e.preventDefault();
        onAction();
      }
    });
    /**
     * onFocus
     */
    _defineProperty(this, "onFocus", () => {
      this.setState({
        focus: true
      });
    });
    /**
     * onBlur
     */
    _defineProperty(this, "onBlur", () => {
      this.setState({
        focus: false
      });
    });
    _defineProperty(this, "focus", () => {
      if (this.buttonRef && this.buttonRef.current) {
        this.buttonRef.current.focus();
      }
    });
    this.state = {
      focus: false
    };
    this.buttonRef = /*#__PURE__*/React.createRef();
  }
  componentDidMount() {
    // $FlowFixMe
    document.addEventListener('keydown', this.handleKeydown);
    setTimeout(this.focus, 500);
  }
  componentWillUnmount() {
    // $FlowFixMe
    document.removeEventListener('keydown', this.handleKeydown);
  }
  render() {
    const {
      onAction,
      show
    } = this.props;
    if (!show) {
      return null;
    }
    return /*#__PURE__*/_jsx("div", {
      className: "ExpiredModal",
      children: /*#__PURE__*/_jsxs("div", {
        className: "info",
        children: [/*#__PURE__*/_jsx("div", {
          children: "Your session has expired. Please start your application again."
        }), /*#__PURE__*/_jsx("div", {
          ref: this.buttonRef,
          className: "button",
          onClick: onAction,
          tabIndex: "0",
          role: "button",
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          children: "Start application"
        })]
      })
    });
  }
}
_defineProperty(ExpiredModal, "defaultProps", {
  onAction: () => null,
  show: false
});
export default ExpiredModal;